import React, { useState, useEffect } from 'react';
import RadioQuestion from './questions/RadioQuestion';
import CheckboxQuestion from './questions/CheckboxQuestion';
import MultiPartQuestion from './questions/MultiPartQuestion';
import { generateContextualQuestion } from '../utils/aiQuestionGenerator';

function SurveyPage({ symptom, question, answers, progress, onAnswer, onNext, onBack, isAnswered, darkMode, toggleDarkMode }) {
  const [displayQuestion, setDisplayQuestion] = useState(null);
  const [isLoadingAI, setIsLoadingAI] = useState(false);

  // Generate AI-enhanced question when question changes
  useEffect(() => {
    if (!question) return;

    if (question.type === 'assurance') {
      setDisplayQuestion(question);
      setIsLoadingAI(false);
      return;
    }

    // 重置状态
    setIsLoadingAI(true);
    setDisplayQuestion(null);

    // Generate AI version, passing symptomId and userName
    const userName = sessionStorage.getItem('herbalzen_user_name');
    generateContextualQuestion(question, answers, symptom.id, userName)
      .then(aiQuestion => {
        setDisplayQuestion(aiQuestion);
        setIsLoadingAI(false);
      })
      .catch(err => {
        console.error('AI generation failed:', err);
        setDisplayQuestion(question);
        setIsLoadingAI(false);
      });
  }, [question, symptom.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!displayQuestion && isLoadingAI) {
    return (
      <div className="survey-container">
        {/*
        <div className="header">
          <h1>{symptom.icon} {symptom.title}</h1>
          <p>Please answer the following questions, and we will match a perfect formula for you.</p>
        </div>
        */}

        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>

        <div className="question-card">
          <div className="ai-loading-fullscreen">
            <span className="loading-spinner-large"></span>
            <span className="loading-text">Analyzing your answers...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!displayQuestion) return null;

  return (
    <div className="survey-container">
      {/*
      <div className="header">
        <h1>{symptom.icon} {symptom.title}</h1>
        <p>Please answer the following questions, and we will match a perfect formula for you.</p>
      </div>
      */}

      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }}></div>
      </div>

      <div className="question-card">
        {displayQuestion.type !== 'assurance' && (
          <div className="question-number">Question {displayQuestion.number}</div>
        )}
        
        {displayQuestion.type === 'assurance' ? (
          <div className="assurance-content">
            <div className="assurance-icon">{displayQuestion.icon}</div>
            <h2 className="assurance-title">{displayQuestion.title}</h2>
            <p className="assurance-text">{displayQuestion.text}</p>
          </div>
        ) : (
          <>
            <div className="question-text">
              {displayQuestion.text}
              {displayQuestion.isAIGenerated && (
                <span className="ai-badge" title="AI Personalized Generation">✨</span>
              )}
            </div>
            {displayQuestion.hint && <div className="question-hint">{displayQuestion.hint}</div>}

            {displayQuestion.type === 'multi-part' ? (
              <MultiPartQuestion
                question={displayQuestion}
                value={answers[displayQuestion.id] || {}}
                onChange={(value) => onAnswer(displayQuestion.id, value)}
              />
            ) : displayQuestion.type === 'checkbox' ? (
              <CheckboxQuestion
                question={displayQuestion}
                value={answers[displayQuestion.id] || []}
                onChange={(value) => onAnswer(displayQuestion.id, value)}
              />
            ) : (
              <RadioQuestion
                question={displayQuestion}
                value={answers[displayQuestion.id]}
                onChange={(value) => onAnswer(displayQuestion.id, value)}
              />
            )}
          </>
        )}
      </div>

      <div className="button-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <button className="btn btn-back" onClick={onBack} style={{ flex: 1 }}>
          ← Back
        </button>
        <button 
          className="btn btn-primary" 
          onClick={onNext}
          disabled={!isAnswered}
          style={{ flex: 2 }}
        >
          {displayQuestion.type === 'assurance' ? 'Continue →' : (progress >= 100 ? 'View Results →' : 'Next Question →')}
        </button>
        <button 
          className="dark-mode-toggle" 
          onClick={toggleDarkMode}
          style={{ position: 'static', margin: 0, width: '48px', height: '48px', flexShrink: 0 }}
        >
          {darkMode ? '☀️' : '🌙'}
        </button>
      </div>

      {/*
      <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '0.75rem', color: '#999', padding: '0 15px' }}>
        AI can make mistakes. For wellness purposes only. Not medical advice.
      </div>
      */}
    </div>
  );
}

export default SurveyPage;